/**
 *
 * Returns the pixel value from the left that the percentage maps to
 */
export const getXValueFromPercent = (
  percent: number,
  sliderPixelWidth: number
) => {
  return percent ? (percent / 100) * sliderPixelWidth : 0;
};
